import {graphql} from '../../__generated__';

export const MUTATION_LOGIN = graphql(`
    mutation login($input: UsersPermissionsLoginInput!) {
        login(input: $input) {
            jwt
            user {
                id
                blocked
            }
        }
    }
`);

export const QUERY_ME = graphql(`
    query me {
        me {
            id
            firstName
            lastName
            role {
                id
                name
            }
            clients {
                documentId
                firstName
                lastName
                phone
                birthday
                group {
                    documentId
                    name
                }
            }
        }
    }
`);
